module.exports = __webpack_public_path__ + "static/media/29.e9f2642b.jpg";